import { Component, OnInit } from '@angular/core';
// import { VersionCheckService } from './version-check.service';
// import { appVer } from './app-ver';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router
} from '@angular/router';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'InSync (Internal)';
  newTransactionsTimer: any;
  loading = false;

  constructor(
    private router: Router,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer
  ) {
    iconRegistry.addSvgIcon(
      'branches',
      sanitizer.bypassSecurityTrustResourceUrl('assets/branches.svg')
    );
    iconRegistry.addSvgIcon(
      'countries',
      sanitizer.bypassSecurityTrustResourceUrl('assets/countries.svg')
    );
    iconRegistry.addSvgIcon(
      'factory',
      sanitizer.bypassSecurityTrustResourceUrl('assets/factory.svg')
    );
    iconRegistry.addSvgIcon(
      'logo',
      sanitizer.bypassSecurityTrustResourceUrl('assets/logo.svg')
    );
    // lets us listen to route calls and display a loading bar under the navbar if we navigated to a new page
    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loading = true;
          break;
        }
        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.loading = false;
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  ngOnInit() {
    /*this.versionCheckService.getVersion()
      .subscribe((data) => {
        if (data.toString() !== appVer.toString()) {
          if (/^([0-9]\.[0-9]{4})$/.test(data.toString())) {
            window.location.reload();
          }
        }
      }
    );
    this.newTransactionsTimer = setInterval(() => {
      this.versionCheckService.getVersion()
        .subscribe((data) => {
          if (data.toString() !== appVer.toString()) {
            if (/^([0-9]\.[0-9]{4})$/.test(data.toString())) {
              window.location.reload();
            }
          }
        }
      );
    }, 1000 * 60 * 15);*/
  }
}
